import { render, staticRenderFns } from "./HistorySenioren.vue?vue&type=template&id=792c75fb&"
import script from "./HistorySenioren.vue?vue&type=script&lang=ts&"
export * from "./HistorySenioren.vue?vue&type=script&lang=ts&"
import style0 from "./HistorySenioren.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTimeline } from 'vuetify/lib/components/VTimeline';
import { VTimelineItem } from 'vuetify/lib/components/VTimeline';
installComponents(component, {VTimeline,VTimelineItem})
